/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import styled, { withTheme } from 'styled-components';
import { ListItem as MuiListItem } from '@material-ui/core';

const ListItem = styled(MuiListItem)`
  background-color: ${(props) =>
    props.theme.palette.type === 'dark'
      ? props.theme.palette.common.backgroundHighlight
      : props.theme.palette.common.white};
  color: ${(props) =>
    props.theme.palette.type === 'dark'
      ? props.theme.palette.common.tan
      : props.theme.palette.common.midBlue};
  border: 1px solid
    ${(props) =>
      props.theme.palette.type === 'dark'
        ? props.theme.palette.common.backgroundDark
        : props.theme.palette.common.white};
  box-shadow: 0 0 8px 0
    ${(props) =>
      props.theme.palette.type === 'dark'
        ? props.theme.palette.common.backgroundDark
        : '#D1D2CF'};
  align-items: flex-start;
  position: relative;
  border-radius: 6px;
  &.with-subplan {
    margin-bottom: 0px;
    box-shadow: none;
  }
  &.sub-plan {
    margin-bottom: 0;
    box-shadow: none;
    padding-top: 4px;
    padding-bottom: 4px;
    .MuiListItemText-root {
      margin: 0;
      padding: 4px 0;
      .MuiTypography-body1 {
        font-size: 13px;
      }
      .MuiTypography-body2 {
        font-size: 13px;
      }
    }
  }
  &:before {
    content: '';
    background-color: ${(props) =>
      props.theme.palette?.product[props.color] ??
      (props.theme.palette.type === 'dark'
        ? props.theme.palette.common.tan
        : props.theme.palette.common.midBlue)};
    height: 98%;
    left: 0;
    position: absolute;
    top: 0;
    width: 5px;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }
`;

export default withTheme(ListItem);
